'use strict';

export default function routes($routeProvider) {
    'ngInject';

    $routeProvider.when('/login', {
            template: require('./login/login.html'),
            controller: 'LoginController',
            controllerAs: 'vm'
        })
        .when('/logout', {
            name: 'logout',
            referrer: '/',
            template: '',
            controller($location, $route, Auth) {
                var referrer = $route.current.params.referrer || $route.current.referrer || '/';
                Auth.logout();
                $location.path('/');
            }
        })
        .when('/settings', {
            template: require('./settings/settings.html'),
            controller: 'SettingsController',
            controllerAs: 'vm',
            authenticate: true
        });
}



// WEBPACK FOOTER //
// ./client/app/account/account.routes.js